<template lang="html">

  <googlemaps-map :center="map.pos_munera" :zoom="map.zoom" map-type-id="terrain"  :options="map.options">
    <googlemaps-marker :position="map.pos"/>
    <googlemaps-marker :position="map.pos_munera"/>
  </googlemaps-map>


</template>

<script lang="js">

 import Vue from 'vue'
 import 'vue-googlemaps/dist/vue-googlemaps.css'
 import VueGoogleMaps from 'vue-googlemaps'

 Vue.use(VueGoogleMaps, {
   load: {
     apiKey: 'AIzaSyCzus3VXdl5xeAmzh_L01I8i66W2XBaoss',
   }
 })

 export default  {
  name: 'mapa',
  data (){
    return {
      map : {
        pos : {
          lat : 38.95028835858712,
          lng : -2.349016346364583
        },
        pos_munera : {
          lat : 39.0282117,
          lng : -2.4730521
        },
        zoom : 15,
        options : {
          disableDefaultUi: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          styles : [
          {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "gamma": "1.00"
            }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels",
            "stylers": [
            {
              "color": "#ba5858"
            }
            ]
          },
          {
            "featureType": "administrative.neighborhood",
            "elementType": "labels",
            "stylers": [
            {
              "color": "#e57878"
            }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "lightness": "65"
            },
            {
              "saturation": "-100"
            },
            {
              "hue": "#ff0000"
            }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "saturation": "-100"
            },
            {
              "lightness": "80"
            }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "poi.attraction",
            "elementType": "labels",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "color": "#dddddd"
            }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "road.highway.controlled_access",
            "elementType": "labels",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "color": "#dddddd"
            }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "color": "#eeeeee"
            }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
            {
              "color": "#ba5858"
            },
            {
              "saturation": "-100"
            }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "all",
            "stylers": [
            {
              "visibility": "off"
            }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "labels.text.fill",
            "stylers": [
            {
              "color": "#ba5858"
            },
            {
              "visibility": "simplified"
            }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [
            {
              "hue": "#ff0036"
            }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "color": "#dddddd"
            }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
            {
              "color": "#ba5858"
            }
            ]
          }
          ]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .vue-google-map{
    min-height: 350px;
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 1023px){
    .vue-google-map{
      min-height: 250px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/parts/mapa.vue